var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SleekText',{attrs:{"xs":"sleek-body-2"},nativeOn:{"click":function($event){return _vm.onClickBankTransfer.apply(null, arguments)}}},[_vm._v("I want a one-time payment through bank-transfer/ cheque.")])}
var staticRenderFns = []

export { render, staticRenderFns }